import type { ConfigType } from '@plone/registry';
import SessionView from '../components/Views/SessionView';

export default function installViews(config: ConfigType) {
  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    Keynote: SessionView,
    Talk: SessionView,
    Training: SessionView,
    OpenSpace: SessionView,
  };
  return config;
}
